import { useEffect, useState } from "react";
import "@/App.css";
import "@/ReferenceTheme.css";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "sonner";
import api from "./lib/api";
import { AppRoutes } from "./AppRoutes";

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  useEffect(() => {
    api.get("/auth/me")
      .then((response) => setUser(response.data))
      .catch(() => setUser(null))
      .finally(() => setChecking(false));
  }, []);
  const signOut = async () => {
    await api.post("/auth/logout");
    setUser(null);
  };
  if (checking) {
    return <div className="app-loading" data-testid="application-loading">Loading CrediFlow…</div>;
  }
  return (
    <BrowserRouter>
      <AppRoutes user={user} onLogin={setUser} onSignOut={signOut} />
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;
